module.exports = __webpack_public_path__ + "assets/img/e2e6724b7861ca0094f553a2688f0b1a.png";